import {
	getSalaryCalculatorPath,
	isSalaryCalculatorSlug,
	SALARY_CALCULATOR_SLUGS,
} from "~/composables/useSalaryCalculatorRoute";

export default defineNuxtRouteMiddleware((to) => {
	const pathParts = to.path.split("/").filter(Boolean);
	if (pathParts.length < 2) return;

	const locale = pathParts[0];
	const slug = pathParts[1];

	if (!isSalaryCalculatorSlug(slug)) return;

	const expectedPath = getSalaryCalculatorPath(locale);
	const expectedSlug = expectedPath.split("/").filter(Boolean)[1];

	if (slug !== expectedSlug) {
		return navigateTo(expectedPath, { redirectCode: 301 });
	}
});

export { SALARY_CALCULATOR_SLUGS };
